import styled from 'styled-components';
import PropTypes from 'prop-types';

const ChevronContainer = styled.div`
  position: absolute;
  ${props => props.right && 'width: 25px; height: 25px; left: -10px; top: 10px'};
  ${props => props.left && 'width: 20px; height: 40px; left: 0; top: 8px'};
  cursor: pointer;
  box-shadow: 0 0 8px 4px rgba(0,0,0,0.08);
  background-color: #FFFFFF;
  ${props => props.right && 'border-radius: 50%'};
  ${props => props.left && 'border-top-right-radius: 20px; border-bottom-right-radius: 20px'};
  z-index: 5;
  svg {
    color: #999b95;
  }
  &:hover {
    cursor: pointer;
    ${props => props.right && 'width: 40px; height: 40px; left: -20px; top: 10px'};
    ${props => props.left && 'width: 30px; height: 40px; left: -5px; top: 8px'};
    ${props => props.right && 'border-radius: 50%'};
    ${props => props.left && 'border-top-right-radius: 40px; border-bottom-right-radius: 40px'};
    .fa-sm {
      font-size: 1.2em;
    }
    svg {
      color: black;
    }
  }
  transition: all 0.2s;
`;

ChevronContainer.propTypes = {
  right: PropTypes.boolean,
  left: PropTypes.boolean,
};

ChevronContainer.defaultProps = {
  left: false,
  right: false,
};
export default ChevronContainer;
